import ErrorAlert from '@/components/errorAlert';
import { routeTree } from '@/routeTree.gen';
import { createRouter } from '@tanstack/react-router';
import { fromExtendedJsonString, toExtendedJsonString } from 'cross-state';

export default createRouter({
  routeTree,
  defaultErrorComponent: ErrorAlert,
  parseSearch: (search) => {
    const params = new URLSearchParams(search.slice(1));
    return Object.fromEntries(
      params.entries().map(([key, value]) => {
        // hand-written or shared URLs may carry plain unquoted strings
        try {
          return [key, fromExtendedJsonString(value)];
        } catch {
          return [key, value];
        }
      }),
    );
  },
  stringifySearch: (search) => {
    const params = new URLSearchParams(
      Object.entries(search)
        .filter(([, value]) => value !== undefined)
        .map(([key, value]) => [
          //
          key,
          toExtendedJsonString(value),
        ]),
    );

    return '?' + params.toString();
  },
  defaultHashScrollIntoView: { behavior: 'smooth', block: 'start', inline: 'nearest' },
});
